import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Space, Statistic, Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { formatRupiah } from '@/lib/format';
export function StockValuationPage() {
    const q = useQuery({
        queryKey: ['toko-valuation'],
        queryFn: async () => (await api.get('/toko/stock/valuation')).data,
    });
    const total = (q.data ?? []).reduce((s, r) => s + parseFloat(r.value), 0);
    const cols = [
        { title: 'SKU', dataIndex: 'sku', width: 130 },
        { title: 'Nama', dataIndex: 'name' },
        { title: 'Kategori', dataIndex: 'category_name', width: 140 },
        { title: 'Unit', dataIndex: 'unit', width: 80 },
        {
            title: 'Qty',
            dataIndex: 'stock_qty',
            width: 120,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: parseFloat(v).toFixed(3) }),
        },
        {
            title: 'Avg Cost',
            dataIndex: 'stock_avg_cost',
            width: 150,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: formatRupiah(v) }),
        },
        {
            title: 'Nilai (Rp)',
            dataIndex: 'value',
            width: 180,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: _jsx("b", { children: formatRupiah(v) }) }),
        },
    ];
    return (_jsxs("div", { children: [_jsx(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: _jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Valuasi Stok" }) }), _jsx(Card, { style: { marginBottom: 16 }, children: _jsx(Statistic, { title: "Total Nilai Persediaan", value: total, formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#0F766E' } }) }), _jsx(Card, { children: _jsx(Table, { rowKey: "product_id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: { pageSize: 30 }, size: "middle" }) })] }));
}
